
import React from "react";

export default function About(props) {

  // Main container style
  const myStyle = {
    color: props.mode === "dark" ? "white" : "black",
    backgroundColor: props.mode === "dark" ? "#042743" : "white",
    padding: "20px"
  };
//   const arrowStyle = {
//   filter: props.mode === "dark" ? "invert(1)" : "invert(0)"
// }

  // // Different accordion item styles
  // const item1Style = {
  //   backgroundColor: props.mode === "dark" ? "#F5F5F5" : "#e3f2fd",
  //   color: props.mode === "dark" ? "white" : "black"
  // };

  // const item2Style = {
  //   backgroundColor: props.mode === "dark" ? "#F5F5F5" : "#d1e7dd",
  //   color: props.mode === "dark" ? "white" : "black"
  // };

  // const item3Style = {
  //   backgroundColor: props.mode === "dark" ? "#F5F5F5" : "#fff3cd",
  //   color: props.mode === "dark" ? "white" : "black"
  // };
  const itemStyle = {
  backgroundColor: props.mode === "dark" ? "#042743" : "#F5F5F5",
  color: props.mode === "dark" ? "white" : "black"
};

  return (
    <div className="container" style={myStyle}>
      <h1 className="my-3">About Us</h1>

      <div className="accordion" id="accordionExample">

        {/* Item 1 */}
        <div className="accordion-item " style={itemStyle}>
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              style={itemStyle}
            >
              Analyze Your Text
            </button>
          </h2>

          <div
            id="collapseOne"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body" style={myStyle}>
              TextUtils gives you a way to analyze your text quickly and efficiently.
              Be it word count, character count or text manipulation.
            </div>
          </div>
        </div>

        {/* Item 2 */}
        <div className="accordion-item" style={itemStyle}>
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              style={itemStyle}
            >
              Free To Use
            </button>
          </h2>

          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body" style={myStyle}>
              TextUtils is a free character counter tool that provides
              instant character count and word count statistics for a given text.
            </div>
          </div>
        </div>

        {/* Item 3 */}
        <div className="accordion-item" style={itemStyle}>
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              style={itemStyle}
            >
              Browser Compatible
            </button>
          </h2>

          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body" style={myStyle}>
              This word counter software works in any web browser
              such as Chrome, Firefox, Edge and Safari.
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}